import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import quarkusApi from '../../api/quarkusApi';

export function useLabOrders() {
  const navigate = useNavigate();

  const [labOrders, setLabOrders] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchLabOrders = useCallback(() => {
    setLoading(true);
    setError(null);
    quarkusApi
      .get('/lab-orders', { headers: { Authorization: sessionStorage.getItem('token') } })
      .then((returnFromApi) => setLabOrders(returnFromApi.data))
      .catch((returnFromApi) => {
        setError(returnFromApi.response?.data);
        console.error('ops! ocorreu um erro' + returnFromApi);
        if (returnFromApi.status === 401) {
          navigate('/expired-session');
        }
      })
      .finally(() => setLoading(false));
  }, [navigate]);

  useEffect(() => {
    fetchLabOrders();
  }, [fetchLabOrders]);

  return { labOrders, isLoading, error, refetch: fetchLabOrders };
}
